import React from 'react';

function PrivacyPolicy({ onBack }) {
  return (
    <div className="legal-page">
      <div className="legal-header">
        <button onClick={onBack} className="legal-back-btn">← Back to Home</button>
        <h1>Privacy Policy</h1>
        <p className="legal-effective-date">Last updated: June 16, 2026</p>
      </div>

      <div className="legal-content">
        <section className="legal-section">
          <h2>1. Introduction</h2>
          <p>
            Welcome to StoryMeal ("we," "our," or "us"). We are committed to protecting your personal 
            information and your right to privacy. This Privacy Policy explains how we collect, use, 
            disclose, and safeguard your information when you visit our website and use our services.
          </p>
          <p>
            Please read this Privacy Policy carefully. If you do not agree with the terms of this 
            Privacy Policy, please do not access the site.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Information We Collect</h2>
          <h3>Personal Information</h3>
          <p>
            We may collect personal information that you voluntarily provide to us when you:
          </p>
          <ul>
            <li>Register for an account (e.g., your name, email address, and profile picture via Google OAuth)</li>
            <li>Submit or publish stories and comments</li>
            <li>Contact us through our website</li>
          </ul>

          <h3>Automatically Collected Information</h3>
          <p>
            When you visit our website, we may automatically collect certain information, including:
          </p>
          <ul>
            <li>Your IP address, browser type, and operating system</li>
            <li>Pages you view and links you click</li>
            <li>The date and time of your visit</li>
            <li>The time spent on pages</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Cookies and Tracking Technologies</h2>
          <p>
            We use cookies and similar tracking technologies to track activity on our website and 
            hold certain information. Cookies are files with a small amount of data that may include 
            an anonymous unique identifier.
          </p>
          <h3>How We Use Cookies</h3>
          <ul>
            <li><strong>Essential Cookies:</strong> Required for the website to function properly</li>
            <li><strong>Preference Cookies:</strong> Remember your preferences and settings</li>
            <li><strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website</li>
            <li><strong>Advertising Cookies:</strong> Used by Google AdSense to serve relevant ads</li>
          </ul>
          <p>
            You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. 
            However, if you do not accept cookies, you may not be able to use some portions of our website.
          </p>
        </section>

        <section className="legal-section">
          <h2>4. Third-Party Services</h2>
          <h3>Google AdSense</h3>
          <p>
            We use Google AdSense to display advertisements on our website. Google AdSense uses cookies 
            to serve ads based on your prior visits to our website or other websites. Google's use of 
            advertising cookies enables it and its partners to serve ads based on your visit to our site 
            and/or other sites on the Internet.
          </p>
          <p>
            You may opt out of personalized advertising by visiting 
            <a href="https://www.google.com/settings/ads" target="_blank" rel="noopener noreferrer"> Google's Ads Settings</a>.
          </p>

          <h3>Google OAuth</h3>
          <p>
            We use Google OAuth for user authentication. When you sign in with Google, we receive your 
            name, email address, and profile picture as provided by your Google account.
          </p>

          <h3>Analytics</h3>
          <p>
            We may use third-party analytics services to help us understand how users interact with our 
            website. These services may collect information about your use of our website over time.
          </p>
        </section>

        <section className="legal-section">
          <h2>5. How We Use Your Information</h2>
          <p>We use the information we collect for the following purposes:</p>
          <ul>
            <li>To provide, operate, and maintain our website</li>
            <li>To improve, personalize, and expand our services</li>
            <li>To communicate with you, including for customer support</li>
            <li>To display personalized advertisements through Google AdSense</li>
            <li>To detect, prevent, and address technical issues and fraud</li>
            <li>To comply with legal obligations</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Data Sharing and Disclosure</h2>
          <p>
            We do not sell your personal information. We may share your information in the following 
            situations:
          </p>
          <ul>
            <li><strong>With Service Providers:</strong> We may share your information with third-party service providers who perform services on our behalf</li>
            <li><strong>For Legal Reasons:</strong> We may disclose your information if required to do so by law or in response to valid legal requests</li>
            <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Data Security</h2>
          <p>
            We implement appropriate technical and organizational security measures to protect your 
            personal information. However, please be aware that no method of transmission over the 
            Internet or method of electronic storage is 100% secure.
          </p>
        </section>

        <section className="legal-section">
          <h2>8. Children's Privacy</h2>
          <p>
            Our services are not intended for children under the age of 13. We do not knowingly collect 
            personal information from children under 13. If we become aware that we have collected 
            personal information from a child under 13, we will take steps to delete that information 
            promptly.
          </p>
        </section>

        <section className="legal-section">
          <h2>9. Your Rights</h2>
          <p>Depending on your location, you may have the following rights regarding your personal information:</p>
          <ul>
            <li>The right to access your personal data</li>
            <li>The right to rectify inaccurate data</li>
            <li>The right to delete your data ("Right to be Forgotten")</li>
            <li>The right to restrict processing of your data</li>
            <li>The right to data portability</li>
            <li>The right to object to processing of your data</li>
            <li>The right to withdraw consent at any time</li>
          </ul>
          <p>
            To exercise any of these rights, please contact us using the information provided below.
          </p>
        </section>

        <section className="legal-section">
          <h2>10. Changes to This Privacy Policy</h2>
          <p>
            We may update our Privacy Policy from time to time. We will notify you of any changes by 
            posting the new Privacy Policy on this page and updating the "Last updated" date at the top.
          </p>
        </section>

        <section className="legal-section">
          <h2>11. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy, please contact us at:
          </p>
          <p><strong>Email:</strong> <a href="mailto:helpdesk@austrasoft.com">helpdesk@austrasoft.com</a></p>
          <p>
            <strong>Website:</strong>{' '}
            <a href="https://austrasoft.com" target="_blank" rel="noopener noreferrer">Austrasoft.com</a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default PrivacyPolicy;